import { useMediaQuery } from "react-responsive";
import { Outlet, useLocation } from "react-router-dom";
import LeftContent from "../LeftContent/LeftContent";
import { useEffect, useState } from "react";
import { getPortfolioRecords } from "app/utils/utility.service";
import { Line } from "react-chartjs-2";
import { InputSwitch } from "primereact/inputswitch";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);
const Portfolio = () => {
  const [data, setData] = useState({
    purchasePrice: "",
    addressOne: "",
    appreciation: "",
    dataPresent: false,
  });
  const state = useLocation();
  const [totalHomeValueElements, setTotalHomeValueElements] = useState([]);
  const [labels, setLabels] = useState([]);
  const [tableView, setTableView] = useState(true);
  useEffect(() => {     
    setTableView(true);
    let totalHomeValueElements1 = [];
    let totalHomeLabelElements1 = [];

    let objList = [];

    data.list?.slice(0,5).forEach((record) => {
      totalHomeValueElements1 = [];
      let grap = getPortfolioRecords(
        record?.inv_value? record?.inv_value : record?.purchasePrice,
        record?.projected_growth ? record?.projected_growth : record?.appreciation,
        record?.purchase_date? record?.purchase_date : record?.purchaseDate
      );
      const obj = {};
      if (grap?.totalHomeValue?.length > 0) {
        grap?.totalHomeValue.forEach((element, index) => {
          if (index === 0) {
            totalHomeValueElements1.push(Number(element).toFixed(2));
          } else {
            if (index % 3 === 0) {
              totalHomeValueElements1.push(Number(element).toFixed(2));
            }
          }
        });
        let path = state.pathname;
        if (path.indexOf("commodities") !== -1)
          obj.name = record?.commodities_name;
        else if (path.indexOf("crypto") !== -1) obj.name = record?.crypto_name;
        else if (path.indexOf("financials") !== -1)
          obj.name = record?.equity_name;
        else if (path.indexOf("realestate") !== -1)
          obj.name = record?.addressOne;

        obj.totalHomeValue = totalHomeValueElements1;
        objList.push(obj);
        if (totalHomeLabelElements1?.length == 0) {
          if (grap?.labels?.length > 0) {
            grap?.labels.forEach((element, index) => {
              if (index === 0) {
                totalHomeLabelElements1.push(element);
              } else {
                if (index % 3 === 0) {
                  totalHomeLabelElements1.push(element);
                }
              }
            });
          }
        }
      }
    });
    setTotalHomeValueElements(objList);
    setLabels(totalHomeLabelElements1);
  }, [data]);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const dataLine = {
    labels,
    datasets: totalHomeValueElements.map((commodity, index) => ({
      label: commodity.name,
      data: commodity.totalHomeValue,
      borderColor: `hsl(${index * 72}, 70%, 50%)`, // Generate distinct colors
      backgroundColor: `hsl(${index * 72}, 70%, 50%)`,
      tension: 0,
    })),
  };

  const options = {
  plugins: {
    legend: {
      labels: {
        color: '#808080',
      },
    },
    datalabels: {
     display:false
      
     
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const label = context.dataset.label || '';
          const value = context.parsed.y;
          return `${label}: $${value.toLocaleString()}`;
        },
      },
    },
  },
  scales: {
    
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return '$' + value.toLocaleString();
        },
      },
    },
  },
  layout: {
    padding: {
      top: 20,
      bottom: 20,
    },
  },
};
  return (
    <div className="HomePurchaseStep3Form">
      <div className="content">
        {isDesktopOrLaptop && (
          <div className="left">
            <LeftContent
              setTotalHomeValueElements={setTotalHomeValueElements}
              setTableView={setTableView}
            />
          </div>
        )}

        <div
          className={`${
            data.dataPresent ? "portfolioRight" : "portfolioRight_w100"
          }`}
        >
          {(state.pathname.indexOf("realestate") !== -1 ||
            state.pathname.indexOf("commodities") !== -1 ||
            state.pathname.indexOf("crypto") !== -1 ||
            state.pathname.indexOf("financials") !== -1) && (
            <div className="align-text-rt mt-4" style={{ width: "98%" }}>
              <label className="mb-3 mr-3" style={{ fontSize: "1.2rem" }}>
                Table View
              </label>
              <InputSwitch
                style={{ transform: "scale(1.25)", transformOrigin: "left" }}
                checked={!tableView}
                onChange={(e) => setTableView(!e.value)}
              ></InputSwitch>
              <label className="mb-3 ml-4" style={{ fontSize: "1.2rem" }}>
                Chart View
              </label>
            </div>
          )}
          {tableView ? (
            <Outlet context={{ data, setData }} />
          ) : (
            <div>
              <div className="flex">
                <div className="bannerStyle col-12 mb-4 mt-2">{data.title}</div>
              </div>
              <Line data={dataLine} options={options} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
